import { chakra, defineRecipe } from '@plurall/elo-v3';

const goalEvolutionChartRecipe = defineRecipe({
  className: 'goal-evolution-card__chart',
  base: {
    height: '280px',
    minWidth: 0,
    marginTop: 'padding.large',

    '& .chart-root': {
      padding: '0 !important',
      background: 'transparent',
      borderRadius: '0',
      height: '100%',
    },

    '& .recharts-default-legend': {
      display: 'flex',
      justifyContent: 'center',
      gap: 'gap.large',
    },
  },
});

const goalEvolutionTooltipRecipe = defineRecipe({
  className: 'goal-evolution-card__tooltip',
  base: {
    display: 'flex',
    flexDirection: 'column',
    background: 'background.primary',
    border: '1px solid {colors.border.secondary}',
    borderRadius: 'border.radius.3xsmall',
    boxShadow: 'sm',
    paddingBlock: 'padding.3xsmall',
    paddingInline: 'padding.xsmall',
    gap: 'gap.3xsmall',
  },
});

const goalEvolutionTooltipLabelRecipe = defineRecipe({
  className: 'goal-evolution-card__tooltip-label',
  base: {
    fontSize: 'font.size.xsmall',
    color: 'text.secondary',
    marginBottom: 'padding.3xsmall',
    fontWeight: 'font.weight.bold',
  },
});

const goalEvolutionTooltipItemRecipe = defineRecipe({
  className: 'goal-evolution-card__tooltip-item',
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: 'gap.xsmall',
    justifyContent: 'space-between',
    fontSize: 'font.size.small',
    color: 'text.primary',
  },
});

const goalEvolutionTooltipLeftRecipe = defineRecipe({
  className: 'goal-evolution-card__tooltip-left',
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'gap.3xsmall',
  },
});

const goalEvolutionTooltipDotRecipe = defineRecipe({
  className: 'goal-evolution-card__tooltip-dot',
  base: {
    display: 'inline-block',
    width: 'size.8',
    height: 'size.8',
    borderRadius: '50%',
    flex: '0 0 8px',
    alignSelf: 'center',
  },
});

export const GoalEvolutionChartFactory = chakra('div', goalEvolutionChartRecipe);
export const GoalEvolutionTooltipFactory = chakra('div', goalEvolutionTooltipRecipe);
export const GoalEvolutionTooltipLabelFactory = chakra('div', goalEvolutionTooltipLabelRecipe);
export const GoalEvolutionTooltipItemFactory = chakra('div', goalEvolutionTooltipItemRecipe);
export const GoalEvolutionTooltipLeftFactory = chakra('div', goalEvolutionTooltipLeftRecipe);
export const GoalEvolutionTooltipDotFactory = chakra('span', goalEvolutionTooltipDotRecipe);
